import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser'
import { TranslateService } from '@ngx-translate/core';
import { forkJoin } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PageTitleService {

  constructor(
    private _route: Router,
    private _titleService: Title,
    private _translateService: TranslateService
  ) { }

  setTitleBasedOnRoute(includePrefix: boolean = true, translationsBasePath: string = 'pageTitles') {
    let finalTitlePage = '';
    let pageNamePart = this._route.url.split('/').pop();
    pageNamePart = (pageNamePart!.split('?').length > 1) ? pageNamePart?.split('?')[0] : pageNamePart;
    if (pageNamePart) {
      let translationPathForPageTitle = `${translationsBasePath}.${pageNamePart}`;

      const translations$ = forkJoin({
        prefix: this._translateService.get(`${translationsBasePath}.prefix`),
        pageTitle: this._translateService.get(translationPathForPageTitle)
      });

      translations$.subscribe(translation => {
        finalTitlePage = translation.pageTitle;
        if (includePrefix) finalTitlePage = `${translation.prefix} - ${finalTitlePage}`;
        this._titleService.setTitle(finalTitlePage);
      });
    }
    else {
      this._titleService.setTitle(`Client Portal - ${pageNamePart?.toLowerCase()}`);
    }
  }
}
